import type { CreatorSignalQualityResponse } from '../types/organizer';

const HYPOTHESIS_1_NAME = 'hypothesis-1';

/**
 * Derives the number of events from Creator Quality signal response.
 * Uses hypothesis-1's noOfEvents to align with listings package.
 * Returns 0 when data is missing or invalid.
 */
export const getNumberOfEventsFromCreatorSignal = (
    creatorSignalData: CreatorSignalQualityResponse | null | undefined,
): number => {
    if (!creatorSignalData?.hypothesis?.length) {
        return 0;
    }

    const hypothesis1 = creatorSignalData.hypothesis.find(
        (h) => h.name === HYPOTHESIS_1_NAME,
    );

    if (
        !hypothesis1 ||
        !('value' in hypothesis1) ||
        typeof (hypothesis1.value as { noOfEvents?: string }).noOfEvents !==
            'string'
    ) {
        return 0;
    }

    const parsed = parseInt(
        (hypothesis1.value as { noOfEvents: string }).noOfEvents,
        10,
    );
    return Number.isNaN(parsed) ? 0 : parsed;
};
